var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "container",
      staticClass: "container-fluid mr-summary-dashboard-container",
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              !_vm.helper.isUndefined(_vm.datePlanData)
                ? _c(
                    "el-dialog",
                    {
                      attrs: {
                        visible: _vm.isShowDateModal,
                        title: _vm.datePlanData.date,
                      },
                      on: {
                        "update:visible": function ($event) {
                          _vm.isShowDateModal = $event
                        },
                        close: function ($event) {
                          _vm.datePlanData = null
                        },
                      },
                    },
                    [
                      _c("div", [
                        _c("h4", { staticClass: "m-1" }, [
                          _vm._v(
                            _vm._s(_vm.$t("dashboard.truckCount")) +
                              ": " +
                              _vm._s(
                                _vm.helper.printThousandDecimal(
                                  _vm.datePlanData.truckId.length
                                )
                              )
                          ),
                        ]),
                      ]),
                      _c("div", [
                        _c("h4", { staticClass: "m-1" }, [
                          _vm._v(
                            _vm._s(_vm.$t("dashboard.driverCount")) +
                              ": " +
                              _vm._s(
                                _vm.helper.printThousandDecimal(
                                  _vm.datePlanData.driverId.length
                                )
                              )
                          ),
                        ]),
                      ]),
                      _c("div", [
                        _c("h4", { staticClass: "m-1" }, [
                          _vm._v(
                            _vm._s(_vm.$t("dashboard.estimatedDistance")) +
                              ": " +
                              _vm._s(
                                _vm.helper.printThousandDecimal(
                                  (_vm.datePlanData.estimatedDistance || 0) /
                                    1000
                                )
                              ) +
                              " km"
                          ),
                        ]),
                      ]),
                      _c("div", [
                        _c("h4", { staticClass: "m-1" }, [
                          _vm._v(
                            _vm._s(_vm.$t("dashboard.estimatedTime")) +
                              ": " +
                              _vm._s(
                                _vm.helper.secondsToHms(
                                  _vm.datePlanData.estimatedTime || 0
                                )
                              )
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "mt-3" }, [
                        _c("h4", { staticClass: "m-1" }, [
                          _vm._v(
                            _vm._s(_vm.$t("dashboard.joborderCount")) +
                              ": " +
                              _vm._s(
                                _vm.helper.printThousandDecimal(
                                  _vm.datePlanData.orderId.length
                                )
                              )
                          ),
                        ]),
                      ]),
                      _c("div", [
                        _c("h4", { staticClass: "m-1" }, [
                          _vm._v(
                            _vm._s(_vm.$t("dashboard.totalWaypoints")) +
                              ": " +
                              _vm._s(
                                _vm.helper.printThousandDecimal(
                                  _vm.datePlanData.totalWaypoints || 0
                                )
                              )
                          ),
                        ]),
                      ]),
                      _c("div", [
                        _c("h4", { staticClass: "m-1" }, [
                          _vm._v(
                            _vm._s(_vm.$t("dashboard.completedWaypoints")) +
                              ": " +
                              _vm._s(
                                _vm.helper.printThousandDecimal(
                                  _vm.datePlanData.completedWaypoints || 0
                                )
                              )
                          ),
                        ]),
                      ]),
                      _c("div", [
                        _c("h4", { staticClass: "m-1" }, [
                          _vm._v(
                            _vm._s(_vm.$t("dashboard.assignedWaypoints")) +
                              ": " +
                              _vm._s(
                                _vm.helper.printThousandDecimal(
                                  _vm.datePlanData.assignedWaypoints || 0
                                )
                              )
                          ),
                        ]),
                      ]),
                      _c("div", [
                        _c("h4", { staticClass: "m-1" }, [
                          _vm._v(
                            _vm._s(_vm.$t("dashboard.unassignedWaypoints")) +
                              ": " +
                              _vm._s(
                                _vm.helper.printThousandDecimal(
                                  _vm.datePlanData.unassignedWaypoints || 0
                                )
                              )
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "mt-3" }, [
                        _c("h4", { staticClass: "m-1" }, [
                          _vm._v(
                            _vm._s(_vm.$t("dashboard.onTimePercentage")) +
                              ": " +
                              _vm._s(
                                this.formatOnTimePercentage(_vm.datePlanData)
                              ) +
                              "%"
                          ),
                        ]),
                      ]),
                      _c("div", [
                        _c("h4", { staticClass: "m-1" }, [
                          _vm._v(
                            _vm._s(_vm.$t("dashboard.onTime")) +
                              ": " +
                              _vm._s(
                                _vm.helper.printThousandDecimal(
                                  _vm.datePlanData.onTimeCount || 0
                                )
                              )
                          ),
                        ]),
                      ]),
                      _c("div", [
                        _c("h4", { staticClass: "m-1" }, [
                          _vm._v(
                            _vm._s(_vm.$t("dashboard.late")) +
                              ": " +
                              _vm._s(
                                _vm.helper.printThousandDecimal(
                                  _vm.datePlanData.notOnTimeCount || 0
                                )
                              )
                          ),
                        ]),
                      ]),
                      _c("div", [
                        _c("h4", { staticClass: "m-1" }, [
                          _vm._v(
                            _vm._s(_vm.$t("planning.etaDiscrepancyReason")) +
                              ": " +
                              _vm._s(
                                _vm
                                  .formatLateReason(
                                    _vm.datePlanData.estimateReason
                                  )
                                  .join(", ")
                              )
                          ),
                        ]),
                      ]),
                      _c("div", [
                        _c("h4", { staticClass: "m-1" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("planning.endTimeDiscrepancyReason")
                            ) +
                              ": " +
                              _vm._s(
                                _vm
                                  .formatLateReason(_vm.datePlanData.endReason)
                                  .join(", ")
                              )
                          ),
                        ]),
                      ]),
                      _c(
                        "span",
                        { attrs: { slot: "footer" }, slot: "footer" },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "mt-3",
                              attrs: { type: "primary", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.goToPlan(_vm.datePlanData.date)
                                },
                              },
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: {
                                  icon: "location-arrow",
                                  "aria-hidden": "true",
                                  size: "sm",
                                },
                              }),
                              _c("span", { staticClass: "ml-1" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("planning.dialog.goToPlan"))
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "el-row",
                { attrs: { type: "flex", gutter: 12 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 24, md: 18 } },
                    [
                      _c(
                        "el-row",
                        { attrs: { type: "flex", gutter: 12 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { xs: 24, sm: 12, md: 6 } },
                            [
                              _c(
                                "el-card",
                                {
                                  staticClass: "min-vh-175px",
                                  attrs: { shadow: "always" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "clearfix",
                                      attrs: { slot: "header" },
                                      slot: "header",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("dashboard.filter"))
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c("el-date-picker", {
                                    ref: "month",
                                    staticClass: "w-100",
                                    attrs: {
                                      type: "month",
                                      clearable: false,
                                      placeholder: _vm.$t("dateRange.month"),
                                      "value-format": "yyyy-MM",
                                    },
                                    on: { change: _vm.handleMonthChanges },
                                    model: {
                                      value: _vm.month,
                                      callback: function ($$v) {
                                        _vm.month = $$v
                                      },
                                      expression: "month",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { xs: 24, sm: 12, md: 6 } },
                            [
                              _c(
                                "el-card",
                                {
                                  staticClass: "min-vh-150px number-count-card",
                                  attrs: { shadow: "always" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "clearfix",
                                      attrs: { slot: "header" },
                                      slot: "header",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("dashboard.truckCount"))
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c("number-count", {
                                    attrs: {
                                      number: _vm.helper.get(
                                        _vm.summaryData,
                                        "truckId",
                                        []
                                      ).length,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { xs: 24, sm: 12, md: 6 } },
                            [
                              _c(
                                "el-card",
                                {
                                  staticClass: "min-vh-150px number-count-card",
                                  attrs: { shadow: "always" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "clearfix",
                                      attrs: { slot: "header" },
                                      slot: "header",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "dashboard.estimatedDistance"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "number-count",
                                    {
                                      attrs: { number: _vm.estimatedDistance },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "font-size": "3rem" },
                                        },
                                        [_vm._v("km")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { xs: 24, sm: 12, md: 6 } },
                            [
                              _c(
                                "el-card",
                                {
                                  staticClass: "min-vh-150px number-count-card",
                                  attrs: { shadow: "always" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "clearfix",
                                      attrs: { slot: "header" },
                                      slot: "header",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("dashboard.estimatedTime")
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    { staticStyle: { "font-size": "3rem" } },
                                    [_vm._v(_vm._s(_vm.estimatedTime))]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { xs: 24, sm: 12, md: 6 } },
                            [
                              _c(
                                "el-card",
                                {
                                  staticClass: "min-vh-150px number-count-card",
                                  attrs: { shadow: "always" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "clearfix",
                                      attrs: { slot: "header" },
                                      slot: "header",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("dashboard.joborderCount")
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c("number-count", {
                                    attrs: {
                                      number: _vm.helper.get(
                                        _vm.summaryData,
                                        "orderId",
                                        []
                                      ).length,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { xs: 24, sm: 12, md: 6 } },
                            [
                              _c(
                                "el-card",
                                {
                                  staticClass: "min-vh-150px number-count-card",
                                  attrs: { shadow: "always" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "clearfix",
                                      attrs: { slot: "header" },
                                      slot: "header",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "dashboard.completedWaypoints"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c("number-count", {
                                    attrs: {
                                      number: _vm.helper.get(
                                        _vm.summaryData,
                                        "completedWaypoints",
                                        0
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { xs: 24, sm: 12, md: 6 } },
                            [
                              _c(
                                "el-card",
                                {
                                  staticClass: "min-vh-150px number-count-card",
                                  attrs: { shadow: "always" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "clearfix",
                                      attrs: { slot: "header" },
                                      slot: "header",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "dashboard.assignedWaypoints"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c("number-count", {
                                    attrs: {
                                      number: _vm.helper.get(
                                        _vm.summaryData,
                                        "assignedWaypoints",
                                        0
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { xs: 24, sm: 12, md: 6 } },
                            [
                              _c(
                                "el-card",
                                {
                                  staticClass: "min-vh-150px number-count-card",
                                  attrs: { shadow: "always" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "clearfix",
                                      attrs: { slot: "header" },
                                      slot: "header",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "dashboard.unassignedWaypoints"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c("number-count", {
                                    attrs: {
                                      number: _vm.helper.get(
                                        _vm.summaryData,
                                        "unassignedWaypoints",
                                        0
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 24, md: 6 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "min-vh-150px",
                          attrs: { shadow: "always" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "clearfix",
                              attrs: { slot: "header" },
                              slot: "header",
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("dashboard.onTimePercentage")
                                    ) +
                                    " [" +
                                    _vm._s(_vm.$t("dashboard.onTime")) +
                                    ": " +
                                    _vm._s(
                                      _vm.helper.get(
                                        _vm.summaryData,
                                        "onTimeCount",
                                        0
                                      )
                                    ) +
                                    " - " +
                                    _vm._s(_vm.$t("dashboard.late")) +
                                    ": " +
                                    _vm._s(
                                      _vm.helper.get(
                                        _vm.summaryData,
                                        "notOnTimeCount",
                                        0
                                      )
                                    ) +
                                    "] "
                                ),
                              ]),
                            ]
                          ),
                          _c("gauge-chart", {
                            attrs: {
                              height: "263px",
                              chartData: [_vm.onTimePercentage],
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-card",
                        { attrs: { shadow: "always" } },
                        [
                          _c("h2", { staticClass: "mt-0 mb-3" }, [
                            _vm._v(
                              _vm._s(_vm.$t("dashboard.driverPerformance"))
                            ),
                          ]),
                          _c(
                            "el-table",
                            {
                              ref: "summaryTable",
                              staticStyle: { "max-height": "300px" },
                              attrs: {
                                size: "medium",
                                border: "",
                                data: _vm.summaryTableData,
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  fixed: "",
                                  type: "index",
                                  width: "50",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: { label: _vm.$t("general.driver") },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.getDriverInfo(
                                                  scope.row.driverId,
                                                  "UserName"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  4219139507
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("dashboard.estimatedDistance"),
                                  width: "150",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.helper.printThousandDecimal(
                                                  (scope.row
                                                    .estimatedDistance || 0) /
                                                    1000
                                                )
                                              ) +
                                              " km "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  486951416
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("dashboard.estimatedTime"),
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.helper.secondsToHms(
                                                  scope.row.estimatedTime || 0
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3058542157
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("dashboard.joborderCount"),
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.helper.printThousandDecimal(
                                                  scope.row.joborderCount || 0
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2952666666
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("dashboard.totalWaypoints"),
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.helper.printThousandDecimal(
                                                  scope.row.totalWaypoints || 0
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2442681715
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("dashboard.completedWaypoints"),
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.helper.printThousandDecimal(
                                                  scope.row
                                                    .completedWaypoints || 0
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2569008541
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("dashboard.assignedWaypoints"),
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.helper.printThousandDecimal(
                                                  scope.row.assignedWaypoints ||
                                                    0
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3419979664
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t(
                                    "dashboard.unassignedWaypoints"
                                  ),
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.helper.printThousandDecimal(
                                                  scope.row
                                                    .unassignedWaypoints || 0
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3678517707
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: { label: _vm.$t("dashboard.onTime") },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.helper.printThousandDecimal(
                                                  scope.row.onTimeCount || 0
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  4001631959
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: { label: _vm.$t("dashboard.late") },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.helper.printThousandDecimal(
                                                  scope.row.notOnTimeCount || 0
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1943297730
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("dashboard.onTimePercentage"),
                                  width: "100",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formatOnTimePercentage(
                                                  scope.row
                                                )
                                              ) +
                                              "% "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2060548792
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { xs: 24, sm: 8, md: 5 } }, [
                    _c("div", [
                      _vm._v(_vm._s(_vm.$t("dashboard.hasMoreTrucks"))),
                    ]),
                    _c("div", { staticClass: "bg-indigo-600 h-4" }),
                  ]),
                  _c("el-col", { attrs: { xs: 24, sm: 8, md: 5 } }, [
                    _c("div", [
                      _vm._v(_vm._s(_vm.$t("dashboard.hasLessTrucks"))),
                    ]),
                    _c("div", { staticClass: "bg-blue-600 h-4" }),
                  ]),
                  _c("el-col", { attrs: { xs: 24, sm: 8, md: 5 } }, [
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm.$t("dashboard.hasMoreOnTimeWaypoints"))
                      ),
                    ]),
                    _c("div", { staticClass: "bg-green-600 h-4" }),
                  ]),
                  _c("el-col", { attrs: { xs: 24, sm: 8, md: 5 } }, [
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm.$t("dashboard.hasLessOnTimeWaypoints"))
                      ),
                    ]),
                    _c("div", { staticClass: "bg-red-600 h-4" }),
                  ]),
                  _c("el-col", { attrs: { xs: 24, sm: 8, md: 4 } }, [
                    _c("div", [
                      _vm._v(_vm._s(_vm.$t("dashboard.noCompletedWaypoints"))),
                    ]),
                    _c("div", { staticClass: "bg-gray-600 h-4" }),
                  ]),
                  _c(
                    "el-col",
                    [
                      _c("v-calendar", {
                        ref: "calendar",
                        staticClass: "custom-calendar",
                        attrs: {
                          masks: _vm.masks,
                          attributes: _vm.attributes,
                          "is-dark": _vm.$isDarkTheme,
                          "disable-page-swipe": "",
                          "is-expanded": "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "day-content",
                              fn: function (ref) {
                                var day = ref.day
                                var attributes = ref.attributes
                                return _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-col h-full z-10 overflow-hidden",
                                    class: _vm.getDateClass(day),
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDateClicked(day)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "day-label text-sm" },
                                      [_vm._v(_vm._s(day.day))]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex-grow overflow-y-scroll overflow-x-auto p-1",
                                      },
                                      _vm._l(attributes, function (attr, indx) {
                                        return _c(
                                          "p",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: attr.customData.isShow,
                                                expression:
                                                  "attr.customData.isShow",
                                              },
                                            ],
                                            key: "attr" + indx,
                                            staticClass:
                                              "text-xs leading-tight rounded-sm p-1 mt-0 mb-1",
                                            class: attr.customData.class,
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(attr.customData.title) +
                                                " "
                                            ),
                                          ]
                                        )
                                      }),
                                      0
                                    ),
                                  ]
                                )
                              },
                            },
                          ],
                          null,
                          false,
                          2535357954
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("countdown", {
        ref: "countdown",
        attrs: { defaultRefreshTime: _vm.refreshTime },
        on: { onCountdownZero: _vm.handleCountdownZero },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }